import { render, staticRenderFns } from "./jinr-important.vue?vue&type=template&id=5d9c38fa&scoped=true"
import script from "./jinr-important.vue?vue&type=script&lang=js"
export * from "./jinr-important.vue?vue&type=script&lang=js"
import style0 from "./jinr-important.vue?vue&type=style&index=0&id=5d9c38fa&prod&lang=less"
import style1 from "./jinr-important.vue?vue&type=style&index=1&id=5d9c38fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9c38fa",
  null
  
)

export default component.exports